import pdfMake, { userMark, setMyConfig, makeTableContent } from '../utils/pdf';

function pdfProgramacionPorAgencia(pContent) {
    const columnsItinerarios = [
        {
            key: 'codigo',
            label: 'Cód.',
            width: 30
        },
        'hora:w20',
        'servicio:wauto',
        'pasajero:wauto',
        {
            key: 'nroAdultos',
            label: 'PAX',
            width: 16
        },
        {
            key: 'nroNinos',
            label: 'CHD',
            width: 16
        },
        'hotel:wauto',
        {
            key: 'vueloTourTren',
            label: 'Vuelo / Tour / Tren',
            width: 'auto'
        },
        {
            key: 'observaciones',
            label: 'Obs.:',
            width: '*'
        }
    ]

    const tableItinerarios = makeTableContent([...pContent.itinerarios], columnsItinerarios);


    pdfMake.createPdf({
        info: {
            title: `Programación por agencia - ${pContent.fecha}`
        },
        content: [
            {
                text: 'Reporte Programación por Agencia: ' + pContent.agencia,
                style: 'header'
            },
            `Fecha: ${pContent.fecha}`,
            {
                text: '',
                margin: [0, 0, 0, 2.5]
            },
            tableItinerarios,
            ...(pContent.comentario ? [
                'Comentario:',
                {
                    text: `${pContent.comentario ? pContent.comentario : ''}`,
                    margin: [0, 0, 0, 5]
                }
            ] : []),
            ...userMark(pContent.userMark, pContent.dateMark)
        ],
        ...setMyConfig()
    }).print();
}

export default pdfProgramacionPorAgencia;